import { disputeAlertViewSchema } from "@redotech/redo-dispute-common/dispute-alert-view-definition";
import {
  disputeAlertSortableColumns,
  disputeAlertStatus,
  disputeAlertType,
} from "@redotech/redo-dispute-db-schema/dispute-alert-definition";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import * as z from "zod";

// Merchant Alerts list: the team's synced dispute_alert rows, filtered by
// status/type, sorted, paginated. Mirrors getDisputes.
export const listDisputelyAlerts = {
  name: "listDisputelyAlerts" as const,
  input: z.object({
    statuses: z.array(z.enum(disputeAlertStatus)).optional(),
    types: z.array(z.enum(disputeAlertType)).optional(),
    limit: z.number().int().min(1).max(200).optional(),
    offset: z.number().int().min(0).optional(),
    sortBy: z.enum(disputeAlertSortableColumns).optional(),
    sortDirection: SortDirectionSchema.optional(),
  }),
  output: z.object({
    alerts: z.array(disputeAlertViewSchema),
    total: z.number().int(),
  }),
};
